import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ViewUI from 'view-design'
import './theme/plain.less'
import axios from 'axios'
import qs from 'qs'
import md5 from 'md5'
import vuescroll from 'vuescroll'
import common from './utils/common'
import api from './api/Api'
import moment from 'moment'
import configs from './../configs'
import SmsVerifier from './components/SmsVerifier/index'
import 'babel-polyfill'
import ImagePreview from 'vue-img-viewer'

axios.defaults.withCredentials = true
Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.prototype.$md5 = md5
Vue.prototype.$Api = api
Vue.prototype.$common = common
Vue.prototype.$moment = moment
Vue.prototype.$configs = configs
Vue.prototype.$SmsVerifier = SmsVerifier

Vue.use(ViewUI)
Vue.use(vuescroll, {
  ops: {} // 在这里设置全局默认配置
})
Vue.use(ImagePreview)

Vue.config.productionTip = false

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (instance.$store.getters.smsVerifyCode) {
      var firstSplit = config.url.indexOf('?')
      var urlSearch = firstSplit > 0 ? config.url.substr(firstSplit + 1) : null
      var urlBase = firstSplit > 0 ? config.url.split('?')[0] : config.url
      var querys = urlSearch ? qs.parse(urlSearch, { ignoreQueryPrefix: true }) : {}
      querys.smsCode = instance.$store.getters.smsVerifyCode
      config.url = urlBase + '?' + qs.stringify(querys)
    }
    if (!config.headers.Authorization && config.url.indexOf('aliyun') === -1) {
      if (instance) {
        let tokenFromStore = instance.$store.getters.token
        let tokenFromLocalStorage = window.localStorage.getItem('token')
        // console.log(token)
        let token = tokenFromStore ||tokenFromLocalStorage
        if (token && token !== null) {
          config.headers.Authorization = 'Bearer ' + token
        }
      }
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    let config = error.config
    console.log(error, config)
    if (error.response) {
      // console.log(error.request, error.response.status)
      switch (error.response.status) {
        case 401:
          instance.$Spin.hide()
          instance.$Notice.error({
            title: '您还未登录，请先登录',
            desc: ''
          })
          router.push({ path: '/welcome' })
          break
        case 406:
          router.back()
          instance.$Spin.hide()
          instance.$Notice.error({
            title: '您没有访问该资源的权限！',
            desc: ''
          })
          break
        case 417:
          instance.$Spin.hide()
          var mobile = instance.$store.getters.userInfo.mobile
          // console.log(mobile)
          instance.$SmsVerifier.show({
            show: true,
            mobile: mobile,
            onSubmit: (e) => {
              instance.$store.dispatch('setSmsVerifyCode', e.code)
              // console.log(instance.$store.getters.smsVerifierCbFn)
              return axios(config).then((res) => {
                if (instance.$store.getters.smsVerifierCbFn) {
                  instance.$store.getters.smsVerifierCbFn.call(null, res, instance.$store.getters.smsVerifierCbArgs)
                  setTimeout(() => {
                    instance.$store.dispatch('clearSmsVerifyInfo')
                  }, 2000)
                }
              }).catch(err => {
                if (instance.$store.getters.smsVerifierCbFn) {
                  instance.$store.getters.smsVerifierCbFn.call(null, err, instance.$store.getters.smsVerifierCbArgs)
                  setTimeout(() => {
                    instance.$store.dispatch('clearSmsVerifyInfo')
                  }, 2000)
                }
              })
            },
            onCancel: (action) => {
              console.log('cancelled', action)
              if (action === 'bindMobile') {
                // console.log(instance.$root.$children[0].$children[0])
                // 执行Home组件方法
                if (instance.$root.$children[0].$children[0].showBindMobile) {
                  instance.$root.$children[0].$children[0].showBindMobile()
                } else {
                  instance.$router.push('/dashboard')
                }
              }
            }
          })
          instance.$Notice.warning({
            title: '需要多因素验证！',
            desc: ''
          })
          break
      }
    }
    return Promise.reject(error)   // 返回接口返回的错误信息
    // return Promise.reject(error.response.data.message)   // 返回接口返回的错误信息
  }
)

Vue.prototype.$vuescrollConfig = {
  bar: {
    background: '#777'
  }
}

let instance = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
